export default () => {
  if (global.ENABLE_TEALIUM === 'YES') {
    if (!global.TEALIUM_ACCOUNT) {
      throw new Error('ENABLE_TEALIUM is \'YES\' but TEALIUM_ACCOUNT is not specified');
    }
    if (!global.TEALIUM_PROFILE) {
      throw new Error('ENABLE_TEALIUM is \'YES\' but TEALIUM_PROFILE is not specified');
    }
    if (!global.TEALIUM_ENVIRONMENT) {
      throw new Error('ENABLE_TEALIUM is \'YES\' but TEALIUM_ENVIRONMENT is not specified');
    }
    return {
      isEnabled: true,
      account: global.TEALIUM_ACCOUNT,
      profile: global.TEALIUM_PROFILE,
      environment: global.TEALIUM_ENVIRONMENT,
    };
  } else return {
    isEnabled: false,
  };
};
